import { dual } from '../../Function/dist/effect-Function.esm.js';
import { toString, toJSON, NodeInspectSymbol } from '../../Inspectable/dist/effect-Inspectable.esm.js';
import { empty as empty$1, fromIterable as fromIterable$1, set, has as has$1, remove as remove$1, size as size$1 } from '../../MutableHashMap/dist/effect-MutableHashMap.esm.js';
import { pipeArguments } from '../../Pipeable/dist/effect-Pipeable.esm.js';

/**
 * @since 2.0.0
 */
const TypeId = /*#__PURE__*/Symbol.for("effect/MutableHashSet");

/**
 * @since 2.0.0
 * @category symbol
 */

/**
 * @since 2.0.0
 * @category models
 */

const MutableHashSetProto = {
  [TypeId]: TypeId,
  [Symbol.iterator]() {
    return Array.from(this.keyMap).map(([_]) => _)[Symbol.iterator]();
  },
  toString() {
    return toString(this.toJSON());
  },
  toJSON() {
    return {
      _id: "MutableHashSet",
      values: Array.from(this).map(toJSON)
    };
  },
  [NodeInspectSymbol]() {
    return this.toJSON();
  },
  pipe() {
    return pipeArguments(this, arguments);
  }
};
const fromHashMap = keyMap => {
  const set = Object.create(MutableHashSetProto);
  set.keyMap = keyMap;
  return set;
};

/**
 * @since 2.0.0
 * @category constructors
 */
const empty = () => fromHashMap(empty$1());

/**
 * @since 2.0.0
 * @category constructors
 */
const fromIterable = keys => fromHashMap(fromIterable$1(Array.from(keys).map(k => [k, true])));

/**
 * @since 2.0.0
 * @category constructors
 */
const make = (...keys) => fromIterable(keys);

/**
 * @since 2.0.0
 * @category elements
 */
const add = /*#__PURE__*/dual(2, (self, key) => (set(self.keyMap, key, true), self));

/**
 * @since 2.0.0
 * @category elements
 */
const has = /*#__PURE__*/dual(2, (self, key) => has$1(self.keyMap, key));

/**
 * @since 2.0.0
 * @category elements
 */
const remove = /*#__PURE__*/dual(2, (self, key) => (remove$1(self.keyMap, key), self));

/**
 * @since 2.0.0
 * @category elements
 */
const size = self => size$1(self.keyMap);

export { add, empty, fromIterable, has, make, remove, size };
